import { useWarehousesQuery } from 'hooks/useWarehousesQuery'
import loginStorage from 'utils/loginStorage'

export type UseSelectedWarehouseTenantNamesReturn = {
  warehouseName: string
  tenantName: string
}

// 詳細ヘッダー右上に表示する「選択中の倉庫 / テナント名」を解決する読み取り専用 hook。
// 一覧ヘッダー（useWarehouseSelection）と同じセッション値・倉庫一覧（useWarehousesQuery = 同一
// queryKey・同一 QueryClient）を参照する。一覧 → 詳細の通常遷移では初回表示はキャッシュから即時描画
// される（staleTime=0 のため裏でバックグラウンド再取得は走るが UX 影響なし）。コールドロード / 直リンク
// 時のみ実データ取得を待つ。詳細画面は表示のみのため選択変更やセッション書き込みは行わない。
export const useSelectedWarehouseTenantNames = (): UseSelectedWarehouseTenantNamesReturn => {
  const session = loginStorage.getWarehouseSession()
  const warehouseId = typeof session.warehouseId === 'number' ? session.warehouseId : null
  const tenantId = typeof session.tenantId === 'number' ? session.tenantId : null

  const { warehouseList } = useWarehousesQuery()

  const warehouse = warehouseList.find((w) => w.id === warehouseId) ?? null
  const tenant = warehouse?.tenants.find((t) => t.id === tenantId) ?? null

  return {
    warehouseName: warehouse?.name ?? '',
    tenantName: tenant?.name ?? '',
  }
}
